import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _createForOfIteratorHelper from "/app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import AwaitLock from 'await-lock';
var lock = new AwaitLock();
/**
 * Adds JavaScript file references to the DOM of the target element. If the
 * script was already added to the target element, it is not added a second
 * time. Makes sure the scripts are loaded in the order of the list.
 * @param scripts a list URLS to JavaScript files
 * @param target the element to which the scripts should be added.
 * @returns ignore the return value
 */
export function addScripts(_x, _x2) {
  return _addScripts.apply(this, arguments);
}
/**
 * Adds links to CSS files to the DOM of the target element. If a stylesheet was
 * already added to the target element, it is not added a second time.
 * @param styles a list of URLs to stylesheets to add
 * @param target the element to which the scripts should be added
 * @param addFontsToHead if true, @font-face rules found in the loaded
 * stylesheets will also be duplicated and added to the head of the document.
 * This is necessary to load fonts that should be displayed inside the shadow
 * DOM.
 */
function _addScripts() {
  _addScripts = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(scripts, target) {
    var existingScripts;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return lock.acquireAsync();
        case 2:
          _context.prev = 2;
          existingScripts = Array.from(target.getElementsByTagName('script')).map(function (el) {
            return el.dataset.h5pSrc;
          });
          _context.next = 6;
          return Promise.all(scripts.map(function (scriptUrl) {
            // Only add scripts once
            if (existingScripts.some(function (existingSrc) {
              return existingSrc === scriptUrl;
            })) {
              return Promise.resolve();
            }
            var scriptTag = document.createElement('script');
            scriptTag.src = scriptUrl;
            // We store the original src used by H5P as the protocol and
            // hostname are part of the src attribute.
            scriptTag.dataset.h5pSrc = scriptUrl;
            scriptTag.async = false;
            scriptTag.defer = true;
            var promise = new Promise(function (res, rej) {
              scriptTag.onload = function () {
                res();
              };
              scriptTag.onerror = rej;
            });
            target.appendChild(scriptTag);
            return promise;
          }));
        case 6:
          _context.prev = 6;
          lock.release();
          return _context.finish(6);
        case 9:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[2,, 6, 9]]);
  }));
  return _addScripts.apply(this, arguments);
}
export function addStylesheets(styles, target) {
  var existingTargetStylesheets = Array.from(target.getElementsByTagName('link')).map(function (el) {
    return el.dataset.h5pHref;
  });
  var _iterator = _createForOfIteratorHelper(styles),
    _step;
  try {
    var _loop = function _loop() {
      var styleUrl = _step.value;
      // Only add stylesheets once
      if (existingTargetStylesheets.some(function (h5pHref) {
        return h5pHref === styleUrl;
      })) {
        return 1; // continue
      }
      var stylesheet = document.createElement('link');
      // We store the original href in the data-h5p-attribute as the browser
      // internally adds the protocol and hostname to the href attribute.
      stylesheet.dataset.h5pHref = styleUrl;
      stylesheet.rel = 'stylesheet';
      stylesheet.href = styleUrl;
      stylesheet.type = 'text/css';
      target.appendChild(stylesheet);
    };
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      if (_loop()) continue;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
}
//# sourceMappingURL=dom-utils.js.map